import { NavLink } from 'react-router-dom';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';
import { useBreadcrumbStore, useCourseStore } from '../../stores/courses';

export const ResoucesViewMemberIdBreadcrumb: BreadcrumbComponentType<
	'memberId' | 'unitId' | 'lessonId' | 'resourceId'
> = ({ match }) => {
	const course = useCourseStore((state) => state.course);
	const breadcrumbs = useBreadcrumbStore((state) => state.breadcrumbs);

	if (course) {
		return (
			<NavLink to={`/units/index/${match.params.memberId}`}>
				{course.name}
			</NavLink>
		);
	}

	if (breadcrumbs.length > 0) {
		return <NavLink to={breadcrumbs[0].url}>{breadcrumbs[0].name}</NavLink>;
	}

	return null;
};
